import styled from "styled-components";

const BackgroundImgStyled = styled.div`
    position: absolute;
    inset:0;
    width: calc(100% - 124px);
    aspect-ratio: 16/9;
    z-index:-1;
`

export default BackgroundImgStyled;